<template>
    <div class="settings" ref="settings">
        <div class="caret" @click="openSettings">
            <i class="fa fa-sliders"></i>
        </div>
        
        <div class="buttons">
            <slot :toggleSettings="openSettings"></slot>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        openSettings() {
            this.$refs.settings.classList.toggle('active')
        }
    }
}
</script>

<style scoped lang="scss">
.settings {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
    background-color: #24282c;
    border-radius: 10px 0px 0px 10px;
    right: 0;
    opacity: 0.5;
    z-index: 9999;

    &.active {
        right: 0;
        opacity: 1;

        .buttons {
            display: block;
        }
    }

    .buttons {
        display: none;
    }

    .btn {
        display: block;
        margin: 10px;
    }

    .caret {
        position: absolute;
        color: white;
        padding: 10px;
        top: 50%;
        transform: translateY(-50%);
        background-color: inherit;
        padding: 20px 5px;
        left: -15px;
        border-radius: 10px;
        cursor: pointer;
    }
}

</style>